import React from 'react';
import ReactDOM from 'react-dom';
import {BrowserRouter, Switch, Route, Redirect} from 'react-router-dom';
import NotFound from "./templates/NotFound";
import './scss/common.scss';
import Navigation from "./partials/Navigation";
import Footer from "./partials/Footer";
import PageTemplate from "./templates/PageTemplate";
import PostTemplate from "./templates/PostTemplate";
import NewsTemplate from "./templates/NewsTemplate";
import ProjectsTemplate from "./templates/ProjectsTemplate";

ReactDOM.render((
    <BrowserRouter>
        <div className='Content'>
            <Navigation/>
            <Switch>
                <Route exact path="/" component={NewsTemplate}/>
                <Route exact path="/projekty/" component={ProjectsTemplate}/>
                <Route path="/projekty/:slug" component={PostTemplate}/>
                <Route path="/aktuality/:slug" component={PostTemplate}/>
                <Redirect exact from='/aktuality/' to='/'/>
                <Route path="/:slug" component={PageTemplate}/>
                <Route component={NotFound}/>
            </Switch>
        </div>
        <Footer/>
    </BrowserRouter>
), document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();
